import {useState, ReactNode} from 'react';

import {ServiceCaseDetailActionsContext} from './ServiceCaseDetailActionsContext';

export function ServiceCaseDetailActionsProvider(props: {children: ReactNode}) {
  const [pendingActions, setPendingActions] = useState<Set<string>>(new Set());

  const executeAction = <T,>(key: string, action: () => Promise<T>): Promise<T> => {
    setPendingActions((prev) => new Set(prev).add(key));

    return action().finally(() => {
      setPendingActions((prev) => {
        const next = new Set(prev);
        next.delete(key);
        return next;
      });
    });
  };

  const isActionPending = (key: string): boolean => pendingActions.has(key);
  const isAnyActionPending = pendingActions.size > 0;

  const getPendingActions = (): string[] => Array.from(pendingActions);
  return (
    <ServiceCaseDetailActionsContext.Provider
      value={{
        executeAction,
        isActionPending,
        isAnyActionPending,
        getPendingActions,
      }}
    >
      {props.children}
    </ServiceCaseDetailActionsContext.Provider>
  );
}
